// @ts-expect-error incompatibility with node16 resolution
import {Dialog, Transition} from '@headlessui/react';
import {
  CartCheckoutButton,
  CartCost,
  CartLineImage,
  CartLinePrice,
  CartLineProductTitle,
  CartLineQuantity,
  CartLineQuantityAdjustButton,
  CartLines,
  CartShopPayButton,
  Link,
  useCart,
  useCartLine,
} from '@shopify/hydrogen';
import {Fragment} from 'react';
import clsx from 'clsx';
import {useCartUI} from './CartUIProvider.client';
import {useEffect, useState} from 'react';
import {MIN_CHECKOUT_PRICE} from '../../constants';
import {IoTrashOutline} from 'react-icons/io5';

export default function Cart(productArtists: any) {
  const {isCartOpen, closeCart} = useCartUI();
  const {totalQuantity} = useCart();
  const [cartHeight, setCartMaxHeight] = useState<number>(0);

  const artistProducts = productArtists.productArtists.cart;

  useEffect(() => {
    setCartMaxHeight(window.innerHeight - 196);
  }, []);

  return (
    <Transition show={isCartOpen}>
      <Dialog onClose={closeCart}>
        {/* Overlay */}
        <Transition.Child
          as={Fragment}
          // enter="ease-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          // leave="ease-in duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            aria-hidden="true"
            className={clsx('fixed z-40', 'inset-0', 'layerDialog')}
          />
        </Transition.Child>

        {/* Panel */}
        <Transition.Child
          as={Fragment}
          // enter="ease-in-out duration-500"
          // enterFrom="translate-y-full"
          // enterTo="translate-y-0"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          // leave="ease-in-out duration-500"
          // leaveFrom="translate-y-0"
          // leaveTo="translate-y-full"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Dialog.Panel
            className={clsx(
              'fixed top-0 z-40 w-full overflow-y-scroll overscroll-none bg-white px-10 pt-10',
            )}
            style={{maxHeight: cartHeight}}
          >
            {totalQuantity > 0 && <CartHeader />}
            {totalQuantity === 0 ? (
              <CartEmpty />
            ) : (
              <>
                <CartItems sanityData={artistProducts} />
                <CartFooter />
              </>
            )}
          </Dialog.Panel>
        </Transition.Child>
      </Dialog>
    </Transition>
  );
}

function CartHeader() {
  return (
    <header
      className={clsx(
        'sticky top-0',
        // 'pt-header'
        'bg-white pt-headerSM',
      )}
    >
      <div className="grid--main hidden lg:grid">
        <div className="col-span-4 hidden lg:block"></div>
        <div className="col-span-8">
          <span className="capitalize text-gray">ref.</span>
        </div>
        <div className="col-span-2">
          <span className="capitalize text-gray">qty.</span>
        </div>
        <div className="col-span-2">
          <span className="capitalize text-gray">eur</span>
        </div>
      </div>
    </header>
  );
}

function CartItems({sanityData}: any) {
  return (
    <div
      role="table"
      aria-label="Shopping cart"
      className="grid gap-10 lg:mt-20 lg:block"
    >
      <CartLines>
        <LineInCart sanityData={sanityData} />
      </CartLines>
    </div>
  );
}

function LineInCart({sanityData}: any) {
  const {merchandise} = useCartLine();
  const {closeCart} = useCartUI();

  const firstVariant = merchandise.selectedOptions[0];
  const hasDefaultVariantOnly =
    firstVariant.name === 'Title' && firstVariant.value === 'Default Title';
  const selectedVariants = merchandise.selectedOptions
    .map((opt) => `${opt.value}`)
    .join(', ');
  // const selectedVariants = merchandise.selectedOptions.map((opt) => `${opt.name}: ${opt.value}`).join(', ')

  return (
    <>
      <div
        role="row"
        className={clsx(
          'grid--main group',
          'mb-5 hidden lg:grid',
          // "hover:bg-lightGray"
          // "hover:bg-highlight"
          // 'odd:bg-lightGray even:bg-white'
        )}
      >
        {/* Image */}
        {/* <div role="cell" className="mr-3 aspect-square w-[66px] flex-shrink-0">
          <Link to={`/products/${merchandise.product.handle}`}>
            <CartLineImage
              className="rounded"
              loaderOptions={{width: 100, height: 100, crop: 'center'}}
            />
          </Link>
        </div> */}

        <div className="col-span-4 block flex justify-end">
          {/* <Link
            to={`/products/${merchandise.product.handle}`}
            onClick={closeCart}
          >
            <CartLineImage
              className="w-[100px] rounded"
              loaderOptions={{width: 500, height: 500, crop: 'center'}}
            />
          </Link> */}
        </div>

        {/* <div className="col-span-4 hidden lg:block"></div> */}

        {/* Title */}
        <div role="cell" className="col-span-8 flex items-center truncate">
          <Link
            to={`/products/${merchandise.product.handle}`}
            onClick={closeCart}
          >
            <CartLineImage
              className="mr-10 w-[100px]"
              loaderOptions={{width: 500, height: 500, crop: 'center'}}
            />
          </Link>
          <div className="truncate">
            <Link
              to={`/products/${merchandise.product.handle}`}
              onClick={closeCart}
              className="inline-block"
            >
              {sanityData && (
                <p className="mr-fontSpace inline-block text-small">
                  {
                    sanityData.find(
                      (product: any) =>
                        product.slug === merchandise.product.handle,
                    ).artistName
                  }
                  {/* , */}
                </p>
              )}
              <CartLineProductTitle
                className="link text-small text-gray group-hover:text-main"
                as="p"
              />
              {!hasDefaultVariantOnly && (
                <p className="truncate text-small">{selectedVariants}</p>
              )}
            </Link>
          </div>
        </div>

        {/* Variants */}
        {/* <div role="cell" className="col-span-2 flex items-center truncate">
          {!hasDefaultVariantOnly && (
            <p className="truncate text-small">{selectedVariants}</p>
          )}
        </div> */}

        {/* Quantity + Remove */}
        <div role="cell" className="col-span-2 flex items-center truncate">
          {/* Quantity */}
          <CartItemQuantity />
        </div>

        {/* Price */}
        <div className="col-span-2 flex items-center">
          <CartLinePrice
            withoutCurrency={true}
            withoutTrailingZeros={true}
            className="text-small"
          />
          <span className="ml-fontSpace">€</span>
        </div>
      </div>
      <div className="LINE-BLOCK-MOBILE lg:hidden">
        <div className="grid grid-cols-[105px_1fr] gap-x-10">
          <div className="IMG">
            <Link
              to={`/products/${merchandise.product.handle}`}
              onClick={closeCart}
            >
              <CartLineImage
                className="w-[105px] rounded"
                loaderOptions={{width: 500, height: 500, crop: 'center'}}
              />
            </Link>
          </div>
          <div className="MAIN">
            {/* <div className="LINE-REF grid grid-cols-duo gap-5">
              <div className="w-[40px] capitalize text-gray">ref.</div>
              <Link
                to={`/products/${merchandise.product.handle}`}
                onClick={closeCart}
                className="flex flex-wrap"
              >
                {sanityData && (
                  <p className="mr-fontSpace">
                    {
                      sanityData.find(
                        (product: any) =>
                          product.slug === merchandise.product.handle,
                      ).artistName
                    }
                    ,
                  </p>
                )}
                <CartLineProductTitle className="link text-small text-gray group-hover:text-main" />
              </Link>
            </div> */}
            <Link
              to={`/products/${merchandise.product.handle}`}
              onClick={closeCart}
            >
              {sanityData && (
                <p className="mr-fontSpace">
                  {
                    sanityData.find(
                      (product: any) =>
                        product.slug === merchandise.product.handle,
                    ).artistName
                  }
                </p>
              )}
              {/* <br className='lg:hidden'/> */}
              <CartLineProductTitle className="link text-small text-gray group-hover:text-main" />
            </Link>
            {/* {!hasDefaultVariantOnly && (
              <div className="LINE-REF grid grid-cols-duo gap-5">
                <div className="w-[40px] capitalize text-gray">var.</div>
                <div>{selectedVariants}</div>
              </div>
            )} */}
            {!hasDefaultVariantOnly && <div>{selectedVariants}</div>}
            {/* <div className="LINE-REF mt-10 grid grid-cols-duo gap-5">
              <div className="w-[40px] capitalize text-gray">qty.</div>
              <CartItemQuantity />
            </div> */}
            <CartItemQuantity isMt={true} />
            {/* <div className="LINE-REF grid grid-cols-duo gap-5">
              <div className="w-[40px] capitalize text-gray">eur</div>
              <span>
                <CartLinePrice
                  as="span"
                  withoutCurrency={true}
                  withoutTrailingZeros={true}
                  className="text-small"
                />
                <span className="ml-fontSpace">€</span>
              </span>
            </div> */}
            <span>
              <CartLinePrice
                as="span"
                withoutCurrency={true}
                withoutTrailingZeros={true}
                className="text-small"
              />
              <span className="ml-fontSpace">€</span>
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

function CartItemQuantity({ isMt }: any) {
  return (
    <div className={clsx("flex gap-5", isMt ? 'mt-20' : '')}>
      <CartLineQuantityAdjustButton
        adjust="decrease"
        aria-label="Decrease quantity"
        className="disabled:pointer-events-all group/sm disabled:cursor-wait"
      >
        <span className="text-gray group-hover/sm:text-main">-</span>
        {/* <span>[</span> */}
        {/* <span className="text-gray group-hover/sm:text-main">-1</span> */}
        {/* <span>]</span> */}
      </CartLineQuantityAdjustButton>
      <CartLineQuantity as="div" className="w-20 text-center text-small" />
      <CartLineQuantityAdjustButton
        adjust="increase"
        aria-label="Increase quantity"
        className="disabled:pointer-events-all group/sm disabled:cursor-wait"
      >
        <span className="text-gray group-hover/sm:text-main">+</span>
        {/* <span>[</span> */}
        {/* <span className="text-gray group-hover/sm:text-main">+1</span> */}
        {/* <span>]</span> */}
      </CartLineQuantityAdjustButton>
      {/* Remove */}
      <CartLineQuantityAdjustButton
        adjust="remove"
        aria-label="Remove from cart"
        className="disabled:pointer-events-all group/sm disabled:cursor-wait"
      >
        {/* <span>[</span> */}
        <span className="flex text-gray group-hover/sm:text-main">
          <IoTrashOutline className="mr-2" size={16} />
          Remove
        </span>
        {/* <span className="text-gray group-hover/sm:text-main">×</span> */}
        {/* <span className="text-gray group-hover/sm:text-main">delete</span> */}
        {/* <span>]</span> */}
      </CartLineQuantityAdjustButton>
    </div>
  );
}

function CartFooter() {
  const {cost} = useCart();
  const {closeCart} = useCartUI();
  const totalCost = cost?.totalAmount.amount;

  return (
    <footer className="sticky bottom-0 mt-[53px] bg-white pb-10 pt-20">
      <div
        role="table"
        aria-label="Cost summary"
        className="grid grid-cols-16 gap-x-5 gap-y-20"
      >
        <div className="hidden lg:col-span-4 lg:block"></div>
        <div className="col-span-16 flex w-full text-small text-main lg:hidden">
          <span>Total: EUR</span>
          <span>
            <CartCost
              as="span"
              amountType="subtotal"
              className="ml-fontSpace"
              withoutCurrency={true}
              withoutTrailingZeros={true}
            />
            <span className="ml-fontSpace">€</span>
          </span>
        </div>
        <div
          role="row"
          className="col-span-16 lg:col-span-8"
          // style={{ gridArea: '1/5/2/13' }}
        >
          <div className="text-small text-gray">
            Shipping costs and taxes will be calculated at checkout
          </div>
        </div>
        <div
          role="row"
          className="col-span-2 hidden lg:block"
          // style={{ gridArea: '1/13/2/15' }}
        >
          <p className="text-small text-main">Total</p>
        </div>
        <div
          role="row"
          className="col-span-2 hidden lg:block"
          // style={{ gridArea: '1/15/2/17' }}
        >
          <span className="text-main">
            <CartCost
              as="span"
              amountType="subtotal"
              className="text-small"
              withoutCurrency={true}
              withoutTrailingZeros={true}
            />
            <span className="ml-fontSpace">€</span>
          </span>
        </div>
      </div>

      <div className="lg:grid--main mt-20 pt-edit">
        <div className="col-span-14 hidden lg:block"></div>
        <div className="col-span-2">
          <div className="flex flex-wrap gap-5 lg:grid">
            <div className="group relative w-fit">
              {totalCost && parseInt(totalCost) >= MIN_CHECKOUT_PRICE && (
                <CartCheckoutButton className="absolute inset-0 overflow-hidden opacity-0">
                  Checkout
                </CartCheckoutButton>
              )}
              <p
                className={clsx(
                  'border border-main px-10 py-2 text-main group-hover:bg-main group-hover:text-white',
                  totalCost &&
                    parseInt(totalCost) < MIN_CHECKOUT_PRICE &&
                    '!border-gray !text-gray group-hover:bg-white group-hover:text-gray',
                )}
              >
                Checkout
              </p>
            </div>
            <div className="group relative w-fit">
              {totalCost && parseInt(totalCost) >= MIN_CHECKOUT_PRICE && (
                <CartShopPayButton className="absolute inset-0 overflow-hidden opacity-0" />
              )}
              <p
                className={clsx(
                  'border border-shopPay px-10 py-2 text-shopPay group-hover:bg-shopPay group-hover:text-white',
                  totalCost &&
                    parseInt(totalCost) < MIN_CHECKOUT_PRICE &&
                    '!border-gray !text-gray group-hover:!bg-white group-hover:text-gray',
                )}
              >
                Shop Pay
              </p>
            </div>
            <div className="group relative w-fit cursor-pointer">
              <p
                className={clsx(
                  'border border-gray px-10 py-2 text-gray group-hover:!bg-gray group-hover:text-white',
                  totalCost &&
                    parseInt(totalCost) < MIN_CHECKOUT_PRICE &&
                    '!border-gray !text-gray group-hover:!bg-white group-hover:text-gray',
                )}
                onClick={closeCart}
              >
                Continue shopping
              </p>
            </div>
          </div>
          {totalCost && parseInt(totalCost) < MIN_CHECKOUT_PRICE && (
            <p className="mt-20 text-main">{MIN_CHECKOUT_PRICE} minimum.</p>
          )}
        </div>
      </div>
    </footer>
  );
}

function CartEmpty() {
  const {closeCart} = useCartUI();
  return (
    <div className="mb-10 grid pt-headerSM lg:grid-cols-16 lg:gap-5 lg:pt-header">
      <div className="col-span-14 hidden lg:block"></div>
      <button
        className="col-span-2 text-right text-small text-main lg:text-left"
        onClick={closeCart}
        type="button"
      >
        Your cart is empty.
      </button>
    </div>
  );
}
